import BaseResp from './baseResp';

export default class AddAddressResp extends BaseResp {
  constructor({ apiKey, message, code }) {
    super({ apiKey, message, code });
  }
}
